// src/FrontPage.js
import React from "react";
import "./FrontPage.css";

export default function FrontPage({ onOpen, onShowAuth, onShowSignup, isSignedIn, user }) {
  const items = [
    {
      icon: "📊",
      title: "Winning strategy starts with knowing the market",
      subtitle: "Get the market values and trends",
    },
    {
      icon: "💡",
      title: "Enhance your investment decisions",
    },
    {
      icon: "🔎",
      title: "Find superior markets",
      subtitle: "Find out the best performing markets",
    },
    {
      icon: "⏱️",
      title: "Explore opportunities timing",
      subtitle: "Our unique Algorithm for markets turning points",
    },
  ];

  return (
    <div className="frontpage">
      <div className="fp-container">
      <header className="fp-header">
        <h1>🤖 AlgoreitAI — Real Estate Insights</h1>
        {/* CTA buttons moved to the top header bar in App.js for alignment */}
      </header>

      <div className="fp-grid">
        {items.map((it, idx) => (
          <div key={idx} className="fp-card" aria-label={it.title}>
            <div className="fp-ill" aria-hidden>
              {it.icon}
            </div>
            <div className="fp-text">
              <div className="fp-title">{it.title}</div>
              {it.subtitle ? <div className="fp-desc">{it.subtitle}</div> : null}
            </div>
          </div>
        ))}
      </div>

      {/* Start Button */}
      <div
        style={{
          maxWidth: 1100,
          margin: '32px auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16
        }}
      >
        {isSignedIn ? (
          <>
            <div style={{ fontSize: 16, color: '#334155', fontWeight: 600 }}>
              Welcome back, {user?.firstName || user?.primaryEmailAddress?.emailAddress}! 👋
            </div>
            <button
              onClick={() => {
                onOpen('dashboard');
              }}
              style={{
                padding: '16px 48px',
                fontSize: 20,
                fontWeight: 700,
                color: '#fff',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                border: 'none',
                borderRadius: 12,
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(16, 185, 129, 0.25), 0 10px 20px rgba(16, 185, 129, 0.15)',
                transition: 'all 0.3s ease',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 8px rgba(16, 185, 129, 0.3), 0 15px 25px rgba(16, 185, 129, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(16, 185, 129, 0.25), 0 10px 20px rgba(16, 185, 129, 0.15)';
              }}
            >
              📊 Enter Dashboard
            </button>
          </>
        ) : (
          <button
            onClick={onShowAuth}
            style={{
              padding: '16px 48px',
              fontSize: 20,
              fontWeight: 700,
              color: '#fff',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              borderRadius: 12,
              cursor: 'pointer',
              boxShadow: '0 4px 6px rgba(102, 126, 234, 0.25), 0 10px 20px rgba(102, 126, 234, 0.15)',
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 8px rgba(102, 126, 234, 0.3), 0 15px 25px rgba(102, 126, 234, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(102, 126, 234, 0.25), 0 10px 20px rgba(102, 126, 234, 0.15)';
            }}
          >
            🚀 Start
          </button>
        )}
      </div>

      {/* Version & feedback block under the start box */}
      <div
        style={{
          maxWidth: 1100,
          margin: '16px auto 0',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 16,
          flexWrap: 'wrap',
        }}
        aria-label="Version and feedback"
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 12px',
            borderRadius: 999,
            border: '1px solid #dbeafe',
            background: '#eef2ff',
            color: '#1e3a8a',
            fontWeight: 700,
            fontSize: 21,
            boxShadow: '0 1px 2px rgba(16,24,40,0.06)',
          }}
        >
          <span aria-hidden>β</span>
          <span>version</span>
        </div>
        <div style={{ fontSize: 14, color: '#334155', fontWeight: 600 }}>We would love feedback</div>
        <div style={{ fontSize: 14, color: '#0f172a' }}>AlgoreitAI@gmail.com</div>
      </div>
      </div>
    </div>
  );
}
